import { render, staticRenderFns } from "./lt-subtask-list.vue?vue&type=template&id=83730760&scoped=true&"
import script from "./lt-subtask-list.vue?vue&type=script&lang=js&"
export * from "./lt-subtask-list.vue?vue&type=script&lang=js&"
import style0 from "./lt-subtask-list.vue?vue&type=style&index=0&id=83730760&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83730760",
  null
  
)

export default component.exports